/* 全局有三个参数
 * # ___PROJECT 项目名称
 * # ___ENV 环境模式 development || production
 * # ___VERSION 版本号（不带v）
 * 建议项目内只在本文件([project]/config.js)上直接使用，其他的项目模块与组件等用到则使用 set 的方法传入配置
*/
// import "babel-polyfill";

//通用函数库
import * as Com from './../common'
import * as Utils from "build/plugs/utils";
window.Com = Com;
window.Utils = Utils;
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
import { Upload, TimePicker, DatePicker, Button, Select, Table, Loading, Pagination, Tooltip, Popover, Switch, Checkbox, Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Upload).use(TimePicker).use(DatePicker).use(Button).use(Select).use(Table).use(Loading).use(Pagination).use(Tooltip).use(Popover).use(Switch).use(Checkbox);

// 加载通用样式
import 'static/css/reset.css'

import Router from "./router";
//获取数据插件 like ajax
import * as ServiceConfig from './serviceConfig'
import * as Service from 'build/plugs/service'
//ServiceConfig => {devUrl,resources,caches}
Vue.use(Service, {
	...ServiceConfig //展开基础数据

	//如果定义了该方法,当 接口返回数据 status !== 1 时将调用该方法
	//用于统一处理接口 报错信息
	, alertFn: (msg = '未知信息', status) => {
		Message.error(msg)
	}
	, baseData: {}
});

//主页面组件
import Index from './index.vue'
Com.getToken = () => {
	let token = window.localStorage.getItem("token")
	return token
}

//去掉提示 可取消
Vue.config.productionTip = false;

//开始
const vm = new Vue({
	router: Router
	, template: "<App/>"
	, components: {

	}
	, render: h => h(Index)
}).$mount('#app');

Com.set({ vm })




// WEBPACK FOOTER //
// core-dms/projects/candao-dms-std/fgfRegister/config.js